export default {
    error404: 'Oops, wrong turn!',
    cantValidateUnsubscribe: "Can't unsubscribe right now. Please try again later.",
    unsubscribeTitle: 'Unsubscription completed',
    unsubscribeText: 'You will no longer receive email communications from {dealer}.',
};
